import { render } from "./InvisibleWatermark.vue?vue&type=template&id=d2ae6fd4&scoped=true"
import script from "./InvisibleWatermark.vue?vue&type=script&lang=js"
export * from "./InvisibleWatermark.vue?vue&type=script&lang=js"

import "./InvisibleWatermark.vue?vue&type=style&index=0&id=d2ae6fd4&scoped=true&lang=css"

import exportComponent from "/builds/cloud-game/goc_backstage_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2ae6fd4"]])

export default __exports__